import Monostate from './monostate';

type FailedQueue = {
  resolve: (value: unknown) => void;
  reject: (error: unknown) => void;
};

export default class FailedQueueMonostate
  implements Monostate<Array<FailedQueue>>
{
  private static failedQueue: Array<FailedQueue> = [];

  public getValue() {
    return FailedQueueMonostate.failedQueue;
  }

  public setValue(failedQueue: Array<FailedQueue>) {
    FailedQueueMonostate.failedQueue = failedQueue;
  }

  public add(failedQueue: Array<FailedQueue>) {
    FailedQueueMonostate.failedQueue.push(...failedQueue);
  }

  public clear() {
    FailedQueueMonostate.failedQueue = [];
  }
}
